import { render, staticRenderFns } from "./RoadmapPage.vue?vue&type=template&id=fc077766&scoped=true&"
import script from "./RoadmapPage.vue?vue&type=script&lang=js&"
export * from "./RoadmapPage.vue?vue&type=script&lang=js&"
import style0 from "./RoadmapPage.vue?vue&type=style&index=0&id=fc077766&scoped=true&lang=css&"
import style1 from "./RoadmapPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc077766",
  null
  
)

export default component.exports